// extracted by mini-css-extract-plugin
module.exports = {"container":"_1X7jHXCmTmtwZuDDDl7jX_"};